<template>
  <div class="main">
    <HeadTop v-show="changeShow" @handleOpen="openNotice"></HeadTop>
    <HeadTopA v-show="!changeShow"></HeadTopA>
    <div style="display:flex;direction:row;position:relative;">
      <HeadLeft v-on:specialtyListFunction="changeMenuList"></HeadLeft>
      <div style="display:flex;flex-direction:column;width:100%">
        <component :is="currentBizComponent" v-on:specialtyListFunction="changeMenuList" :ifshow="ifshow" :infoDetail="infoDetail"></component>
        <Footer @footerChange="footerChange" @specialtyListFunction="changeMenuList"></Footer>
      </div>
      <News v-show="changeShow" v-on:specialtyListFunction="changeMenuList"></News>
      <HeadRight :showFooter="showFooter" v-on:specialtyListFunction="changeMenuDeatil" v-show="changeShow"></HeadRight>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="50%" :before-close="handleModelClose" :center="true" :title="title">
      <div v-html="htmlContent" class="dialogHeight"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="handleClose">已知悉</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeadLeft from "../components/common/headLeft";
import HeadTop from "../components/common/headTop";
import HeadTopA from "../components/common/headTopA";
import Banner from "../components/common/banner";
import Footer from "../components/common/footer";
import HeadRight from "../components/common/headRight";
import News from "@/views/index/news";
import Infomation from "@/views/index/infomation";
import Outline from "@/views/outline/index";
import Traffic from "@/views/traffic/index";
import TrafficTab from "@/views/traffic/trafficTab";

import Specialty from "@/views/specialty/index";
import NewsInfo from "@/views/newsInfo/index";
import Hotel from "@/views/hotel/index";
import Guide from "@/views/guide/index";
import TabGuide from "@/views/guide/tabGuide";

import Ticket from "@/views/ticket/index";
import specialtyList from "@/views/specialty/specialtyList.vue";
import NoticeList from "@/views/notice/index.vue";
import National from "@/views/national/index.vue";

import RealTimeData from "@/views/realTimeData/index.vue";
import TabApage from "@/views/outline/tabApage.vue";// 概括 - 走进武夷山
import TabBpage from "@/views/outline/tabBpage.vue";


import Food from "@/views/food/index";
import TabFood from "@/views/food/tabFood";

import NewsTab from "@/views/newsInfo/newsTab.vue";

import Entertainment from "@/views/entertainment/index";
import EnterTab from "@/views/entertainment/enterTab.vue";


import TabHotel from "@/views/hotel/tabHotel.vue";


import TabParty from "@/views/party/tabParty.vue";
import TabFaZhi from "@/views/party/tabFaZhi.vue";


import Company from "@/views/footer/company.vue";
import Copyright from "@/views/footer/copyright.vue";
import Link from "@/views/footer/link.vue";
import ContactUs from "@/views/footer/contactUs.vue";
import { getEffectiveNotice } from "@/api/common";
import CultureList from "@/views/culture/list";
export default {
  name: "HelloWorld",
  components: {
    CultureList,
    National,
    NoticeList,
    ContactUs,
    Link,
    Copyright,
    Company,
    TabGuide,
    TabBpage,
    TabFood,
    TabParty,
    TabFaZhi,
    TabHotel,
    EnterTab,
    NewsTab,
    HeadTopA,
    HeadTop,
    HeadLeft,
    Banner,
    Footer,
    HeadRight,
    News,
    Infomation,
    Outline,
    Traffic,
    TrafficTab,
    Specialty,
    Hotel,
    Guide,
    Entertainment,
    Food,
    Ticket,
    SpecialtyList: specialtyList,
    RealTimeData,
    TabApage,
  },
  data() {
    return {
      showFooter: true,
      page: 0,
      currentBizComponent: "Banner",
      changeShow: true,
      dialogVisible: false,
      title: "通知",
      htmlContent: "",
      ifshow: true,
      infoDetail: {},
      noticeList: []
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        deviceId == 0
          ? ""
          : (this.chooseMenu(deviceId), (this.changeShow = true));
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.page;
    },
    noticeIndex() {
      return this.$store.state.noticeIndex;
    }
  },

  created() { },
  methods: {
    //跳转公告页面
    openNotice(data) {
      this.$store.commit("setPage", 0);
      this.currentBizComponent = "NoticeList";
      this.infoDetail = data;
      this.changeShow = false;
      this.ifshow = false;
    },
    //获取公告信息
    async handleGetEffectiveNotice() {
      let info = {};
      info.noticeChannelCode = "website";
      const { code, data } = await getEffectiveNotice(info);
      const arr = data
      if (code == 0) {
        if (arr.length > 0) {
          this.noticeList = data;
          let noticeIndex = this.noticeIndex;
          if (noticeIndex + 1 >= data.length) {
            noticeIndex = 0;
            this.$store.commit("setNoticeIndex", 0);
          }
          this.title = data[noticeIndex].title;
          this.htmlContent = data[noticeIndex].content;
          this.dialogVisible = true;
        } else {
          this.dialogVisible = false;
        }
      }
    },
    handleClose() {
      if (this.noticeList.length == this.noticeIndex + 1) {
        this.$store.commit("setNoticeIndex", 0);
        this.dialogVisible = false;
      } else {
        this.$store.commit("setNoticeIndex", this.noticeIndex + 1);
        this.title = this.noticeList[this.noticeIndex].title;
        this.htmlContent = this.noticeList[this.noticeIndex].content;
      }
    },
    handleModelClose() {
      this.dialogVisible = false;
    },
    //隐藏右边菜单 头部切换
    changeMenuDeatil(data, showType) {
      this.$store.commit("setPage", 0);
      this.ifshow = true;
      this.currentBizComponent = data;
      this.changeShow = showType;
    },
    footerChange(e) {
      this.showFooter = e;
    },
    changeMenuList(data) {
      this.$store.commit("setPage", 0);
      this.currentBizComponent = data;
      this.changeShow = false;
    },
    chooseMenu(key) {
      switch (key) {
        case 1:
          this.currentBizComponent = "Banner";
          this.handleGetEffectiveNotice();
          break;
        case 2:
          this.currentBizComponent = "Outline";
          break;
        case 3:
          this.currentBizComponent = "NewsInfo";
          break;
        case 4:
          this.currentBizComponent = "Traffic";
          break;
        case 5:
          this.currentBizComponent = "Hotel";
          break;
        case 6:
          this.currentBizComponent = "Food";
          break;
        case 7:
          this.currentBizComponent = "Specialty";
          break;
        case 8:
          this.currentBizComponent = "Entertainment";
          break;
        case 9:
          this.currentBizComponent = "Guide";
          break;
        case 10:
          this.currentBizComponent = "Banner";
          break;
        default:
          this.currentBizComponent = "Banner";
      }
    }
  }
};
</script>

<style scoped>
.main {
  max-width: 1920px;
  margin: auto;
}
.dialogHeight {
  max-height: 46.29vh;
  overflow-y: scroll;
}
.dialogHeight::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

/* 滑块 */
.dialogHeight::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #ababab;
}

/* 滑槽 */
.dialogHeight::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue